import React, { Component, Fragment } from 'react';
import AddOnCard from '../cards/AddOnCard';

export default class AddOnItems extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isHidden: false,
            selectedRadio: -99
        };
        this.generateJSXFromData = this.generateJSXFromData.bind(this);
        this.hide = this.hide.bind(this);
        this.show = this.show.bind(this);
        this.generateListViewGroup = this.generateListViewGroup.bind(this);
        this.generateRadioGroup = this.generateRadioGroup.bind(this);
    }

    hide() {
        this.setState({isHidden: true});
    }

    show() {
        this.setState({isHidden: false});
    }

    selectRadio(id) {
        this.props.removeItem(id);
        this.setState({selectedRadio: id});
    }

    generateJSXFromData() {
        var addOnGroups = this.props.addonGroups.map( (val,ind,arr) => {
            let addOnsArray = val.addons;
            return val.control_type === 'radio' ? this.generateRadioGroup(addOnsArray, val.name, ind) : this.generateListViewGroup(addOnsArray, val.name, ind);
        });
        return (<div>
            {addOnGroups}
        </div>)
    }

    generateListViewGroup(addOnsArray, name, index) {
        let selectorsForGroup = addOnsArray.map( (tileVal, tileInd, tileArr) => {
            let isSelected = this.props.addOnChoices[tileVal.id] ? true : false; //coerce into a boolean
            let quantity = isSelected ? this.props.addOnChoices[tileVal.id].quantity : 0;
            return <AddOnCard is_radio={false} id={tileVal.id} isSelected={isSelected} quantity={quantity} name={tileVal.name} key={tileInd} chooseAddOnItem={this.props.chooseAddOnItem} removeItem={this.props.removeItem}
            increaseAddOnQuantity={this.props.increaseAddOnQuantity} decreaseAddOnQuantity={this.props.decreaseAddOnQuantity} price={tileVal.price}
             />;
        });
        return (
            <div key={index} className="row">
                {selectorsForGroup.length > 0 ? (
                <div className='container-fluid'>
                    <h5 className="m-3">{name}</h5>
                    <div className='card-columns-1 w-100 container'>
                        {selectorsForGroup}
                    </div>
                </div>) : ''}
            </div>
        );
    }


    generateRadioGroup(addons, name, index) {
        //TODO: Actual radios
        return this.generateListViewGroup(addons, name, index);
        /* TODO: Make me actual radios 
        let k = (Math.random() * 10000).toFixed();
        return <h1 key={k}>RADIO GROUP</h1> */
    }

    render() {
        let showHideFunction = this.state.isHidden ? this.show : this.hide;
        let anyAddons = false;
        if(this.props.addOnGroups) {
            this.props.addOnGroups.map( (val, ind) => {
                if(val.addons && val.addons.length > 0) anyAddons = true;
            });
        }
        return  (this.props.addonGroups.length >= 1 ) ?
            (<div className='container mt-3 mb-3'>
                <h3 className='mt-3 mb-5' >{this.state.isHidden ? 'Addons' : 'Addons'} <button onClick={showHideFunction} className="m-2 btn btn-primary">{this.state.isHidden ? 'Show' : 'Hide'}</button></h3>
                
                {this.state.isHidden ? '' : this.generateJSXFromData()}
            </div>) : '';
    }
}